import { getEncarteThemeSearchResult } from "../../../../../services/EncarteThemeService";

const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
/**
 * Fetch encarte themes available to plan.
 * @param {string} token - Auth token
 * @param {boolean} premium - Whether to fetch premium themes
 * @param {number} page - Page number (default 0)
 * @param {number} size - Page size (default 10)
 * @returns {Promise<Page<EncarteTheme>>}
 */
export default function useFetchAvailableToPlanThemes() {
  const fetchAvailableToPlanThemes = async (
    token,
    page = 0,
    size = 10,
    premium = false,
  ) => {
    const url = `${BASE_URL}/encartethemes/available-to-plan?premium=${premium}&page=${page}&size=${size}`;
    const res = await fetch(url, {
      headers: { Authorization: token },
    });
    if (!res.ok) throw new Error("Failed to fetch available-to-plan themes");
    const json = await res.json();
    return getEncarteThemeSearchResult(token, json);
  };
  return fetchAvailableToPlanThemes;
}
